export default {
  todayIncome: 'รายได้วันนี้',
  appointmentToday: 'นัดหมายวันนี้',
  totalPatients: 'จำนวนคนไข้ทั้งหมด',
  averagePatientAge: 'อายุคนไข้เฉลี่ย',
  popularTreatments: 'การรักษายอดนิยม (ครั้ง)',
  product: 'สินค้า',
  bestSellingProducts: 'สินค้าขายดี',
  totalTreatments: 'ยอดการรักษา (บาท)',
  totalSellingProduct: 'ยอดขายสินค้า (บาท)',
  treatment: 'การรักษา',
  admissionDate: 'เข้ารับการรักษาเมื่อ',
  total: 'จำนวนการใช้บริการ',
  totalSale: 'จำนวนที่ขายได้',
  productName: 'ชื่อสินค้า',
  todayCash: 'เงินสดวันนี้',
  todayTranfer: 'โอนเงินวันนี้',
  todayCredit: 'บัตรเครดิตวันนี้',
  todayCashBack: 'คืนเงินวันนี้',
  todayOrder: 'ออเดอร์วันนี้',
  cutOffDate: 'วันตัดรอบ',
  aboutToExpire: 'ใกล้หมดอายุ',
  remainingCredit: 'เครดิตคงเหลือ',
  contactAdmin: 'ติดต่อเเอดมิน',
  bath: 'บาท',
  list: 'รายการ',
  appointment: 'นัดหมาย',
  person: 'คน',
  years: 'ปี'
}
